import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

import { useSharingTools } from '../../hooks/useSharingTools';
import { SharingToolsCardWrapper } from '../SharingToolsCardWrapper';

import { ReadyToSharePostsCardPreview } from './components/ReadyToSharePostsCardPreview';

const EMPTY_SHARING_RESOURCE = {
	message: '',
	shareUrl: '',
	previewImageUrl: '',
	petitionTitle: '',
	recommendedGroup: undefined,
};

export const ReadyToSharePostsCard: React.FC = () => {
	const { data, actions } = useSharingTools();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const { facebookPost, instagramStory, isLoading } = data.readyToSharePosts;

	return (
		<SharingToolsCardWrapper
			Preview={
				<ReadyToSharePostsCardPreview
					facebookPost={
						facebookPost || {
							postTypeName: 'ReadyToShareFacebookPost',
							sharingResource: EMPTY_SHARING_RESOURCE,
						}
					}
					instagramStory={
						instagramStory || {
							postTypeName: 'ReadyToShareInstagramStory',
							sharingResource: EMPTY_SHARING_RESOURCE,
						}
					}
					onFacebookPostClick={actions.openRTSFacebookSharingModal}
					onInstagramStoryClick={actions.openRTSInstagramSharingModal}
					isLoading={isLoading}
					petition={petition}
				/>
			}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.title')}
			descriptionKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.description')}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.ready_to_share.primary_action_text',
			)}
			primaryActionOnClick={actions.navigateToReadyToSharePosts}
		/>
	);
};
